// src/data/certificationsData.js

const certificationsData = [
  {
    id: 'akad-fullstack',
    title: 'Akad - FullStack Developer',
    issuer: 'Digital Innovation One',
    image: '/assets/images/certifications/Akad_Fullstack_Developer.png',
    link: '#'
  },
  {
    id: 'cisco-gerenciamento-de-ameacas-ciberneticas',
    title: 'Gerenciamento de Ameaças Cibernéticas',
    issuer: 'Cisco Networking Academy',
    image: '/assets/images/certifications/Cisco-Gerenciamento_de_Ameacas_Ciberneticas.png',
    link: '#'
  },
  {
    id: 'databricks-build-data-pipelines-with-lakeflow',
    title: 'Build Data Pipelines with Lakeflow - Spark Declarative Pipelines',
    issuer: 'Databricks',
    image: '/assets/images/certifications/Databricks-Build_Data_Pipelines_with_Lakeflow_Spark_Declarative_Pipelines-1.png',
    link: '#'
  },
  {
    id: 'databricks-data-ingestion-with-lakeflow-connect',
    title: 'Data Ingestion with Lakeflow Connect',
    issuer: 'Databricks',
    image: '/assets/images/certifications/Databricks-Data_Ingestion_with_Lakeflow_Connect-1.png',
    link: '#'
  },
  {
    id: 'databricks-deploy-workloads-with-lakeflow-jobs',
    title: 'Deploy Workloads with Lakeflow Jobs',
    issuer: 'Databricks',
    image: '/assets/images/certifications/Databricks-Deploy_Workloads_with_Lakeflow_Jobs-1.png',
    link: '#'
  },
  {
    id: 'databricks-devops-essentials-for-data-engineering',
    title: 'DevOps Essentials for Data Engineering',
    issuer: 'Databricks',
    image: '/assets/images/certifications/Databricks-DevOps-Essentials-for-Data-Engineering-1.png',
    link: '#'
  },
  {
    id: 'dsa-fund-python-datascience-e-ml',
    title: 'Python para Análise de Dados, DataScience e ML',
    issuer: 'DSA',
    image: '/assets/images/certifications/DSA-Fund_Python_DataScience_e_ML.png',
    link: '#'
  },
  {
    id: 'dsa-fund-python-e-ia',
    title: 'Fundamentos da Linguagem Python e Aplicações de IA',
    issuer: 'DSA',
    image: '/assets/images/certifications/DSA-Fund_Python_e_IA.png',
    link: '#'
  },
  {
    id: 'oracle-certified-cloud-infrastructure-2025-foundations-associate',
    title: 'Oracle Certified Cloud Infrastructure 2025 - Certified Foundations Associate',
    issuer: 'Oracle',
    image: '/assets/images/certifications/Oracle_Certified_Cloud_Infrastructure_2025_Certified_Foundations_Associate.png',
    link: '#'
  },
  {
    id: 'oracle-certified-data-foundations-associate',
    title: 'Oracle Certified Data Foundations Associate',
    issuer: 'Oracle',
    image: '/assets/images/certifications/Oracle_Certified_Data_Foundations_Associate.png',
    link: '#'
  }
];

export default certificationsData;
